import {useState, useEffect} from "react";
import Head from 'next/head'
import supportsWebP from 'supports-webp';
import AOS from "aos";
import classNames from "classnames";
import Loader from "../components/common/Loader";
import {useRouter} from "next/router";

export default function MainLayout(
    {
        children,
        title,
        alternate,
        description,
        keywords,
        canonical,
        noindex,
        schemaData,
        organizationSchemaData,
        page
    }) {

    const router = useRouter();

    const [isLoading, setIsLoading] = useState(true)
    const [loaded, setLoaded] = useState(false)

    const [origin, setOrigin] = useState('')
    const [host, setHost] = useState('')
    const [webp, setWebp] = useState(false)

    useEffect(() => {

        setOrigin(window.location.origin)
        setHost(window.location.host)

        supportsWebP.then(supported => {
            if (supported) {
                setWebp(true)
            }
        });
    }, [])

    useEffect(() => {
        if(loaded) {
            AOS.init({
                once: true
            });
        }
    }, [loaded])

    useEffect(() => {

        let appLoading = new Promise((resolve, reject) => {
            setTimeout(resolve, 1000, true);
        });

        Promise.all([appLoading]).then(values => {
            setIsLoading(false)
            setLoaded(true)
        })

    }, [])

    return (
        <>
            <Head>
                <title>{title}</title>
                <link rel="icon" type="image/png" href="/img/icons/favicon-96x96.png" sizes="96x96"/>
                <link rel="icon" type="image/svg+xml" href="/img/icons/favicon.svg"/>
                <link rel="shortcut icon" href="/img/icons/favicon.ico"/>
                <link rel="apple-touch-icon" sizes="180x180" href="/img/icons/apple-touch-icon.png"/>
                <meta name="apple-mobile-web-app-title" content="ColdWare"/>
                <link rel="manifest" href="/site.webmanifest"/>
                <meta name="msapplication-TileColor" content="#da532c"/>
                <meta name="theme-color" content="#ffffff"/>
                <meta name="description" content={description}/>
                <meta name="keywords" content={keywords}/>
                {noindex && <meta name="robots" content="noindex, nofollow"/>}
                {!noindex && <>
                    <link rel="alternate" hrefLang="en"
                          href={alternate ? `${origin}/${alternate}` : `${origin}`}/>
                    <link rel="alternate" hrefLang="pt"
                          href={alternate ? `${origin}/pt/${alternate}` : `${origin}/pt`}/>
                    <link rel="alternate" hrefLang="de"
                          href={alternate ? `${origin}/de/${alternate}` : `${origin}/de`}/>
                    <link rel="alternate" hrefLang="es"
                          href={alternate ? `${origin}/es/${alternate}` : `${origin}/es`}/>
                    <link rel="alternate" hrefLang="zh"
                          href={alternate ? `${origin}/zh/${alternate}` : `${origin}/zh`}/>
                    <link rel="alternate" hrefLang="fr"
                          href={alternate ? `${origin}/fr/${alternate}` : `${origin}/fr`}/>
                    <link rel="alternate" hrefLang="tr"
                          href={alternate ? `${origin}/tr/${alternate}` : `${origin}/tr`}/>
                    <link rel="alternate" hrefLang="it"
                          href={alternate ? `${origin}/it/${alternate}` : `${origin}/it`}/>
                    <link rel="alternate" hrefLang="id"
                          href={alternate ? `${origin}/id/${alternate}` : `${origin}/id`}/>
                    <link rel="alternate" hrefLang="ru"
                          href={alternate ? `${origin}/ru/${alternate}` : `${origin}/ru`}/>
                    <link rel="alternate" hrefLang="ar"
                          href={alternate ? `${origin}/ar/${alternate}` : `${origin}/ar`}/>
                    <link rel="alternate" hrefLang="ja"
                          href={alternate ? `${origin}/ja/${alternate}` : `${origin}/ja`}/>
                    <link rel="alternate" hrefLang="ko"
                          href={alternate ? `${origin}/ko/${alternate}` : `${origin}/ko`}/>
                    <link rel="alternate" hrefLang="th"
                          href={alternate ? `${origin}/th/${alternate}` : `${origin}/th`}/>
                    <link rel="alternate" hrefLang="x-default"
                          href={alternate ? `${origin}/${alternate}` : `${origin}`}/>
                    <link rel="canonical"
                          href={router.locale === 'en' ? `${origin}/${canonical}` : `${origin}/${router.locale}${canonical}`}/>
                </>}

                <meta property="og:url" content={origin}/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content=''/>
                <meta property="og:description" content=''/>
                <meta property="og:image" content={`${origin}/img/main/og.png`}/>

                <meta name="twitter:card" content="summary_large_image"/>
                <meta property="twitter:domain" content={host}/>
                <meta property="twitter:url" content={host}/>
                <meta name="twitter:title" content=''/>
                <meta name="twitter:description" content=''/>
                <meta name="twitter:image" content={`${origin}/img/main/og.png`}/>
                {schemaData &&
                    <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(schemaData)}}/>}
                {organizationSchemaData && <script type="application/ld+json"
                                                   dangerouslySetInnerHTML={{__html: JSON.stringify(organizationSchemaData)}}/>}
            </Head>
            <div className={classNames({
                [page]: true,
                "webp": webp
            })}>
                {children}
                <Loader
                    isLoading={isLoading}
                    loaded={loaded}
                />
            </div>
        </>
    )
}